import lc2Png from '../../../assets/images/LC@2x.png';
import config from '../../../config';

class FeedbackViewCtrl {
  constructor() {
    this.url = config.COLLECT_FEEDBACK_URL;
    this.image = lc2Png;
    this.placeholder =
      'Tell us how useful you find this feature for your business.\nWhat do you like about it and what do you think is still missing?';
  }
}

export default FeedbackViewCtrl;
